import { render, staticRenderFns } from "./list-view-items.vue?vue&type=template&id=68eb3d6f&scoped=true"
import script from "./list-view-items.vue?vue&type=script&lang=js"
export * from "./list-view-items.vue?vue&type=script&lang=js"
import style0 from "./list-view-items.vue?vue&type=style&index=0&id=68eb3d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb3d6f",
  null
  
)

export default component.exports